import { useContext, useEffect, useState } from "react";
import { Footer } from "../components/Footer";
import { Header } from "../components/Header";
import { AppContext } from "../App";
import { DateSelection } from "../components/DateSelection";
import { NormalHourSelection } from "../components/NormalHourSelection";
import { BookingExpressHourSelection } from "../components/BookingExpressHourSelection";
import { BookingHourSelection } from "../components/BookingHourSelection";
import { t } from "../i18n";
import { sendEventToParent } from "../utils/helpers";
import { eventResultStatusCodesMapfre } from "../utils/symbols";

export const SelectDateTime = (props) => {
	const { FLOW } = useContext(AppContext);
	const [hours, setHours] = useState(null);
	const nextPage = FLOW === "mapfre" ? "loader" : "bookingEnd";
	const previousPage = "damageGlass";

	return (
		<>
			<Header hours={hours} />
			<Content hours={hours} setHours={setHours} />
			<Footer nextPage={nextPage} previousPage={previousPage} />
		</>
	);
};

const Content = ({ hours, setHours }) => {
	const { FLOW, data, setData, isTransitioning } = useContext(AppContext);
	const [loading, setLoading] = useState(false);

	const handleTimeSelection = (time) => () => {
		let startTime = null;
		let endTime = null;

		if (typeof time === "object") {
			startTime = time.dropoff;
			endTime = time.pickup;
			time = time.dropoff + "-" + time.pickup;
		} else {
			startTime = time;
		}

		setData({
			...data,
			time,
			startTime,
			endTime,
		});
	};

	useEffect(() => {
		if (!data.centerCode || !data.date) return;

		setLoading(true);

		let API_URL = process.env.REACT_APP_API_URL || "http://localhost:3000";

		let controller = new AbortController();
		let options = {
			method: "GET",
			headers: {
				"Content-Type": "application/json",
			},
			signal: controller.signal,
		};

		fetch(
			`${API_URL}/availability/${data.centerCode}/${data.date}?locator=${data.locator}`,
			options
		)
			.then((res) => res.json())
			.then((newData) => {
				if (newData.result === "ok") {
					setHours(newData.shifts);
					setData((prevData) => ({
						...prevData,
						bookingType: newData.shifts.type,
					}));
				}
			})
			.catch((err) => {
				console.error(err);
				sendEventToParent(
					eventResultStatusCodesMapfre.ERROR_5XX,
					data,
					FLOW
				);
			})
			.finally(() => {
				setLoading(false);
				controller.abort();
			});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [data.centerCode, data.date, data.locator, setHours, setData]);

	return (
		<div
			className={
				"content content_calendar kensei_03" +
				(isTransitioning ? " fade-in" : "")
			}
		>
			<div className="content_calendar_date">
				<div className="content_title">
					<h3 className="content_calendar_header">
						{t("Elige cuándo te gustaría venir")}
					</h3>
				</div>

				<DateSelection loading={loading} setLoading={setLoading} />
			</div>

			{data.date && (
				<div className="content_calendar_time">
					<div className="content_title">
						{hours?.type === "bookingExpress" &&
						data.damageArea === "replacement" ? (
							<h3 className="content_calendar_header">
								{t("Elige una franja horaria")}
							</h3>
						) : (
							<h3 className="content_calendar_header">
								{t("Elige una hora")}
							</h3>
						)}
					</div>
					{loading ? (
						<div className="loader">
							<div className="spinner"></div>
						</div>
					) : hours?.type === "normal" ? (
						<NormalHourSelection
							hours={hours?.data}
							selected={data.time}
							onSelect={handleTimeSelection}
						/>
					) : hours?.type === "booking" ? (
						<BookingHourSelection
							hours={hours?.data}
							selected={data.time}
							onSelect={handleTimeSelection}
						/>
					) : hours?.type === "bookingExpress" ? (
						<BookingExpressHourSelection
							hours={hours?.data}
							selected={data.time}
							onSelect={handleTimeSelection}
						/>
					) : (
						hours &&
						((Array.isArray(hours) &&
							hours.every(
								(arr) => Array.isArray(arr) && arr.length === 0
							)) ||
							(Array.isArray(hours.data) &&
								hours.data.every(
									(arr) =>
										Array.isArray(arr) && arr.length === 0
								))) && (
							<div className="content_time_info no-availability">
								<h4>
									{t(
										"No se han podido cargar las horas disponibles"
									)}
								</h4>
								<p>
									{t(
										"Por favor, intenta de nuevo más tarde o para ayudarte a gestionar tu cita."
									)}
								</p>
							</div>
						)
					)}
				</div>
			)}
		</div>
	);
};
